export default "__VITE_ASSET__BFYdm_Lv__"